import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DuperbrowseStreamContext, } from './DuperbrowseStreamContext';
import { getLastViewedItem } from '../redux/selectors';
import { loadDuperbrowse } from '../redux/actionCreators';
import { useDeepEqualMemo } from '../../utils/hooks/useDeepEqualMemo';
var DuperbrowseStreamContextProvider = function (_a) {
    var children = _a.children, stream = _a.stream;
    var lastViewedItem = useSelector(getLastViewedItem);
    var dispatch = useDispatch();
    var memodStream = useDeepEqualMemo(stream);
    var contextProps = useMemo(function () { return ({
        stream: memodStream,
        lastViewedItem: lastViewedItem,
        loadDuperbrowse: function (itemId, streamId) {
            return dispatch(loadDuperbrowse(itemId, streamId));
        },
    }); }, [dispatch, lastViewedItem, memodStream]);
    return (React.createElement(DuperbrowseStreamContext.Provider, { value: contextProps }, children));
};
DuperbrowseStreamContextProvider.displayName =
    'DuperbrowseStreamContextProvider';
export default DuperbrowseStreamContextProvider;
//# sourceMappingURL=DuperbrowseStreamContextProvider.js.map